export default __webpack_public_path__ + "static/media/managing-2plus-bms.952749b2.svg";